import PaymentUnavailable from '../../components/PaymentUnavailable';
export default function PaymentVerified(){return <PaymentUnavailable context="unverified payment route"/>}
